const getTalkingPointDetailResponse = (response) => {
  const { talkingPoint } = response || {};

  return {
    brand: talkingPoint?.brandId ? { value: talkingPoint.brandId } : '',
    title: talkingPoint?.title || '',
    isSpecialEvent: talkingPoint?.isSpecialEvent || false,
    host: talkingPoint?.assignedHosts || [],
    startTime: talkingPoint?.startTime?.slice(0, 5) || '',
    endTime: talkingPoint?.endTime?.slice(0, 5) || '',
    displayDateRange: [
      talkingPoint?.startDate ? new Date(`${talkingPoint.startDate}T00:00:00`) : null,
      talkingPoint?.endDate ? new Date(`${talkingPoint.endDate}T00:00:00`) : null,
    ],
    productHighlight: (talkingPoint?.productHighlights || []).map((product) => ({
      value: product?.sku,
      image: product?.imagePath,
      imageKey: product?.imageKey,
      label: product?.productName,
      note: product?.note,
      isManual: product?.isManual ?? null,
    })),
    sections: (talkingPoint?.sections || []).map((section) => ({
      title: section?.title,
      description: section?.content,
      orderIndex: section?.orderIndex,
    })),
    rawData: talkingPoint,
  };
};

export default getTalkingPointDetailResponse;
